import React from "react"
import { useLocation, NavLink } from "react-router-dom";
import { useEffect, useState } from "react"
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal
} from "react-bootstrap";
import { Link } from 'react-router-dom';
import BonusCreateModal from "components/Bonus/BonusCreateModal"
import toast, { Toaster } from "react-hot-toast"
import API from "components/Apis/API"
import { apiUrl } from 'config';
 
const AutomationMain = () => {
  const [Data, setData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [run, setRun] = useState(false);


  const fetchData = async () =>
    {
      const toastId = toast.loading("Loading data...")
      const url = "admin/invoice-posting/ready-to-print"
      const response = await API.getData(url)
      const data = response
      if (data.status) {
        setData(data.data)
      }
      toast.dismiss(toastId)
    }
  
    const runAutomation = async () =>
      {
        setRun(true)
        const toastId = toast.loading("Executing task...")
        setMessages([])
        const eventSource = new EventSource(apiUrl+'admin/automation/sse');
        
        eventSource.onmessage = function(event) {
            setMessages(prevMessages => [...prevMessages, event.data]);
            console.log(messages)
        };

        eventSource.onerror = function() {
            eventSource.close();
            toast.dismiss(toastId)
            setRun(false)
        };

        return () => {
            eventSource.close();
            toast.dismiss(toastId)
            setRun(false)
        };
      }
      const hasAction = (message) => {
        return message.includes("ACTION");
      };

  useEffect(() => {

  }, [])


  return (
    <>
    <Toaster position='bottom-right' />
      <Container fluid>
        <Row>
          <Col md="6">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  Automations
                  
                </Card.Title>
                <p className="card-category">
                  All automations
                </p>

              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped table">
                  <thead>
                    <tr>
                      <th className="border-0">Name</th>
                      <th className="border-0">Description</th>
                      <th className="border-0">Actions</th>

                    </tr>
                  </thead>
                  <tbody>
               
                    <tr>
                      <td>Invoice Posting</td>
                      <td>Post invoices in automated way</td>
                      <td><a className="btn btn-primary btn-xm" onClick={() => runAutomation()}>Run</a></td>


                    </tr>
                  
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
          <Col md="6">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  Automation Result
                </Card.Title>
                <p className="card-category">
                  Result for each step will be logged in here
                </p>

              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <div className="terminal-body" style={{padding:"20px"}}>
                {messages.map((row,i)=> (

                  <p className={`result-line ${hasAction(row) ? 'action-result' : 'status-result'}`}>{row}</p>

                ))}
             
                {run == true ? (
                <div class="spinner-grow spinner-grow-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                ): "" }
                </div>
                
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>

  
    </>
  );
}

export default AutomationMain;
